<template>
  <div id="step-4" class="multi-step-form active-step">
    <div class="d-flex align-content-center">
      <p>
        <img src="@/assets/arrow-left.svg" alt="OK" @click="prevEtapa()" />
      </p>
    </div>
    <div
      class="d-flex align-content-center align-flex-title"
      style="margin-top: -55px"
    >
      <p>Vamos iniciar a simulação do seu plano de saúde?</p>
    </div>
    <div class="align-flex-title">
      <h3>Preencha o seus dados</h3>
    </div>
    <div
      class="row input-field-simulador"
      style="display: block; text-align: left"
    >
      <p>Nome completo:</p>
      <b-form-input
      @keydown="onlyLetters($event)"
      :formatter="formatter"
        v-model="nome"
        placeholder="Digite aqui o seu nome completo"
        :class="{
          'statusok-fontbold': nome.length > 2 && nome.indexOf(' ') > 0,
        }"
      ></b-form-input>
      <img
        v-if="nome.length > 2 && nome.indexOf(' ') > 0"
        class="statusok-check"
        src="@/assets/statusok.svg"
        alt="OK"
      />
      <small
        >Vamos utilizar o seu nome para incluir no contrato, caso queira fazer a
        compra.</small
      >
    </div>
    <div
      class="row input-field-simulador"
      style="display: block; text-align: left"
    >
      <p>Data de nascimento:</p>
      <date-picker
        v-model="datanasc"
        v-mask="'##/##/####'"
        valueType="format"
        format="DD/MM/YYYY"
        placeholder="Informe aqui a sua data de nascimento"
        :editable="true"
        input-class="form-control"
        :class="{
          'statusok-fontbold-datepicker': datanasc.length > 9,
        }"
        :disabled-date="(date) => (date > new Date() ? true : false)"
      ></date-picker>
      <!-- <img
                    v-if="datanasc.length > 9"
                    class="statusok-check"
                    src="@/assets/statusok.svg"
                    alt="OK"
                  /> -->
      <small> Precisamos da sua idade para entregar o plano correto. </small>
    </div>
    <!-- TESTE VALIDAÇÃO -->
    <div v-if="errors.length">
      <b v-for="erro in errors" :key="erro">{{ erro }}</b>
    </div>
    <!-- TESTE VALIDAÇÃO -->
    <div class="row align-flex-dependentes input-field-simulador">
      <div>
        <p>Você possui dependentes?</p>
      </div>
      <div>
        <b-button @click="habilitaDependentes(true)">Sim</b-button>
        <b-button @click="semDependentes()"> Não </b-button>
      </div>
    </div>
    <div v-if="incluirDependente">
      <div
        class="row row-insert-dependentes"
        style="
          text-align: left;
          margin-top: 80px;
          padding-bottom: 31px;
          border-bottom: 1px solid #e0e0e0;
        "
      >
        <b-col md="9" sm="6" style="padding-left: 0px">
          Quantidade de dependentes:
        </b-col>
        <b-col
          md="3"
          sm="6"
          style="
            display: flex;
            justify-content: space-between;
            padding-right: 0px;
          "
        >
          <button
            class="control-dep"
            style="background: #ffffff"
            @click="removerDependente()"
          >
            <img src="@/assets/remove-dep.svg" />
          </button>
          <span class="qtd-dep">{{ dependentes.length }}</span>
          <button
            class="control-dep"
            style="background: #ffffff"
            @click="adicionarDependente()"
          >
            <img src="@/assets/add-dep.svg" />
          </button>
        </b-col>
      </div>
      <div
        class="dep-div"
        v-for="(dependente, i) in dependentes"
        :key="i"
        style="margin: 0"
      >
        <div
          class="row"
          style="display: block; text-align: left; margin-top: 50px"
        >
          <p>Nome do dependente:</p>
          <b-form-input
            :formatter="formatter"
            @keydown="onlyLetters($event)"
            v-model="dependente.NomeDep"
            placeholder="Digite o nome do dependente"
            :class="{
              'statusok-fontbold':
                dependente.NomeDep.length > 2 &&
                dependente.NomeDep.indexOf(' ') > 0,
            }"
          ></b-form-input>
          <img
            v-if="
              dependente.NomeDep.length > 2 &&
              dependente.NomeDep.indexOf(' ') > 0
            "
            class="statusok-check"
            src="@/assets/statusok.svg"
            alt="Check"
          />
        </div>
        <div
          class="row input-field-simulador"
          style="display: block; text-align: left"
        >
          <p>Grau de parentesco do dependente:</p>
          <b-form-select
            v-model="dependente.GrauParentescoDep"
            :options="options_grauparentesco"
            :class="{
              'statusok-fontbold': dependente.GrauParentescoDep != null,
            }"
            :style="[
              dependente.GrauParentescoDep != null
                ? {
                    background:
                      'url(' +
                      require('@/assets/statusok.svg') +
                      ') no-repeat right 2.6% center #ffffff',
                  }
                : '',
            ]"
          >
            <b-form-select-option :value="null">
              Selecione aqui
            </b-form-select-option>
          </b-form-select>
        </div>
        <div
          class="row input-field-simulador"
          style="display: block; text-align: left"
        >
          <p>Data de nascimento do dependente:</p>
          <date-picker
            v-model="dependente.DataNascDep"
            v-mask="'##/##/####'"
            valueType="format"
            format="DD/MM/YYYY"
            placeholder="Informe a data de nascimento do dependente"
            :editable="true"
            input-class="form-control"
            :class="{
              'statusok-fontbold-datepicker': dependente.DataNascDep.length > 9,
            }"
            :disabled-date="(date) => (date > new Date() ? true : false)"
            @change="habilitaDependentes(false)"
          ></date-picker>
        </div>
      </div>
      <!-- TESTE VALIDAÇÃO -->
      <div v-if="errors.length">
        <b v-for="erro in errors" :key="erro">{{ erro }}</b>
      </div>
      <!-- TESTE VALIDAÇÃO -->
    </div>
    <div class="row finaliza-dep" style="margin-top: 100px">
      <div v-if="finalizaprocesso" @click="setEtapa('PD')">
        <b-button
          class="btn-alianca btn-next btn-next-continuar-simule-nomargin"
          :class="{ 'btn-clicked': exibefinaliza === true }"
          :disabled="!exibefinaliza"
          >CONFIRMAR E CONTINUAR</b-button
        >
        <b-button
          class="btn-alianca btn-next btn-icon-next"
          :class="{ 'btn-clicked-icon': exibefinaliza === true }"
          :disabled="!exibefinaliza"
          ><font-awesome-icon icon="angle-right" class="icon-arrow-right"
        /></b-button>
      </div>
    </div>
  </div>
</template>

<script>
import listarGrauParentesco from "@/services/listarGrauDependentes";
import textFormatter from "@/utils/textFormatter.js"
import store from "@/store";

export default {
  name: "StepQuatro",
  data() {
    return {
      errors: [],
      incluirDependente: false,
      dependentes: [],
      finalizaprocesso: false,
      exibefinaliza: false,
      options_faixaremuneracao: [],
      options_grauparentesco: [],
    };
  },
  computed: {
    etapa: {
      get() {
        return store.getters.getAliancaProxEtapa;
      },
      set(newVal) {
        store.commit("mutAliancaProxEtapa", newVal);
      },
    },
    nome: {
      get() {
        return store.getters.getSimuleAquiNome;
      },
      set(newVal) {
        store.commit("mutSimuleAquiNome", newVal);
      },
    },
    datanasc: {
      get() {
        return store.getters.getSimuleAquiDataNasc;
      },
      set(newVal) {
        store.commit("mutSimuleAquiDataNasc", newVal);
      },
    },
    tipoorgaoentidade() {
      return store.getters.getSimuleAquiTipoOrgaoEntidade;
    },
  },
  mounted() {
    document.getElementById("step-progress").value = 6.67 * 3;

    this.resetPlanosLista();

    store.commit("mutSimuleAquiLoader", false);
  },
  methods: {
    onlyLetters(e){
      textFormatter.onlyLetters(e);
    },
    formatter(val){
        return val.toUpperCase();
      },
    resetPlanosLista() {
      store.commit("mutAliancaBreakPlanos", true);
      store.commit("mutAliancaStatusAnalise", false);
      store.commit("mutAliancaPlanosLista", []);
      store.commit("mutAliancaResetPlanosListaFormatado", []);
    },
    prevEtapa() {
      store.commit("mutAliancaProxEtapa", "step-3-alt");
    },
    habilitaDependentes(incluirDep) {
      if (!this.options_grauparentesco.length) {
        this.listarParentesco();
      }
      this.getFaixaRemuneracaoDep();

      if (incluirDep) {
        this.incluirDependente = true;
        this.finalizaprocesso = true;
        this.exibefinaliza = false;

        if (!this.dependentes.length) {
          this.adicionarDependente();
        }
      } else {
        this.finalizaprocesso = true;
        this.exibefinaliza = true;
      }
    },
    adicionarDependente() {
      this.dependentes.push({
        NomeDep: "",
        CPFDep: "",
        GrauParentescoDep: null,
        DataNascDep: "",
        sexo: null,
        nomemae: "",
        estadocivil: null,
        documentoTipodep: null,
        documentoNumerodep: "",
        documentoOrgao: null,
        documentoUf: null,
        documentoDtExpedicao: "",
        certidaonascidovivo: "",
      });
    },
    removerDependente() {
      if (this.dependentes.length > 1) {
        this.dependentes.pop();
      } else {
        this.dependentes = [];

        this.incluirDependente = false;
        this.finalizaprocesso = true;
        this.exibefinaliza = true;
      }
    },
    async listarParentesco() {
      const grauparentesco = await listarGrauParentesco();

      this.options_grauparentesco = grauparentesco.map((el) => {
        return {
          value: el.BRP_CODIGO,
          text: el.BRP_DESCRI,
        };
      });
    },
    getFaixaRemuneracaoDep() {
      this.options_faixaremuneracao =
        store.getters.getAliancaListaFaixaRemuneracao;
    },
    semDependentes() {
      this.dependentes = [];

      this.incluirDependente = false;
      this.finalizaprocesso = true;
      this.exibefinaliza = true;

      this.setEtapa("NPD");
    },
    validaStep() {
      this.errors = [];

      if (!this.nome) {
        this.errors.push("Preencha seu nome completo");
        return false;
      }

      if (this.nome.length < 3 || this.nome.indexOf(" ") == 0) {
        this.errors.push("Preencha seu nome completo corretamente");
        return false;
      }

      if (this.datanasc.length > 0 && this.datanasc.length < 10) {
        this.errors.push("Data de nascimento incompleta");
        return false;
      }
      if (!this.datanasc) {
        this.errors.push("Preencha a data de nascimento");
        return false;
      }

      if (this.incluirDependente) {
        let accerros = [0, 0, 0, 0, 0, 0];

        for (let i = 0; i < this.dependentes.length; i++) {
          if (!this.dependentes[i].NomeDep) accerros[0]++;
          // if (!this.dependentes[i].CPFDep) accerros[1]++
          if (!this.dependentes[i].GrauParentescoDep) accerros[2]++;
          if (
            this.dependentes[i].DataNascDep.length > 0 &&
            this.dependentes[i].DataNascDep.length.length < 8
          )
            accerros[3]++;
          if (!this.dependentes[i].DataNascDep) accerros[4]++;
          // if (this.tipoorgaoentidade == "orgao") {
          //   if (!this.dependentes[i].FaixaRemuneracaoDep) accerros[5]++;
          // }
        }

        if (accerros[0] > 0) {
          this.errors.push("Preencha o nome de todos os dependentes");
          return false;
        }
        if (accerros[2] > 0) {
          this.errors.push(
            "Selecione o grau de parentesco de todos dependentes"
          );
          return false;
        }
        if (accerros[3] > 0) {
          this.errors.push(
            "Data de nascimento de algum dos dependentes está incompleta"
          );
          return false;
        }
        if (accerros[4] > 0) {
          this.errors.push(
            "Preencha a data de nascimento de todos dependentes"
          );
          return false;
        }
        if (accerros[5] > 0) {
          this.errors.push(
            "Preencha a faixa de remuneração de todos dependentes"
          );
          return false;
        }
      }

      return true;
    },
    setEtapa(meta) {
      if (this.validaStep()) {
        store.commit("mutAliancaBreakPlanos", false);
        store.commit("mutAliancaNome", this.nome);
        store.commit("mutAliancaDataNasc", this.datanasc);

        if (meta == "PD") {
          store.commit("mutAliancaPossuiDep", "Sim");
          store.commit("mutAliancaObjDependentes", this.dependentes);

        } else {
          store.commit("mutAliancaPossuiDep", "Não");

        }

        this.etapa = "step-5";

        store.dispatch("disAliancaPlanosFiltros");
        store.dispatch("disAliancaPlanosLista");
      }
    },
  },
};
</script>